module.exports = __webpack_public_path__ + "media/tape-nav/commerce-influence-branded-content-e5c55770.svg";